import React, { useState } from "react"
import { View, StyleSheet, ScrollView } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors } from "@Constants/baseStyles"
import { useRecoilState, useRecoilValue } from "recoil"
import { UserService } from "@Services/User.service"
import { passwordCodeAtom, passwordResetEmailAtom } from "@Recoil/Atom/passwordCodeAtom"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { areEqual, isStrongPassword, isValidEmail } from "@Utils/utils"
import SimpleGoBackBtn from "@Components/SimpleGoBackBtn/SimpleGoBackBtn"
import { PasswordValidatorContent } from "@Screens/Register/PasswordValidatorContent"

const defaultpasswords = {
    password: "",
    retypePassword: ""
}

export const PasswordCreateForm = ({ navigation }) => {
    const [loading, setLoading] = useState(false)
    const code = useRecoilValue(passwordCodeAtom)
    const [mail, setMail] = useRecoilState(passwordResetEmailAtom)
    const [passwords, setPasswords] = useState(defaultpasswords)
    const performResetPassword = () => {
        setLoading(true)
        const payload = {
            token: code,
            password: passwords.password,
            retypePassword: passwords.retypePassword,
            email: mail,
            fromMobile: 1
        }

        if (mail.length > 0 && isValidEmail(mail) && code.length === 6) {
            console.log(payload)
            UserService.resetPassword(payload)
                .then((response) => {
                    const status = response.data?.status
                    if (status === "INVALID_ACTIVATION_TOKEN") {
                        ShowToast({ type: "error", message: "Code de réinitialisation incorrect" })
                        navigation.navigate("PasswordForgotCode")
                    } else {
                        setMail("")
                        ShowToast({ type: "success", message: "Mot de passe réinitialisé avec succès" })
                        navigation.navigate("PasswordChangedSuccess")
                    }
                    setLoading(false)
                })
                .catch((e) => {
                    ShowToast({ type: "error", message: message.serverError })
                    setLoading(false)
                })
        } else {
            alert("Adresse email / code invalide")
            setLoading(false)
        }
    }

    const isNotValidPassword =
        isStrongPassword(passwords.password) &&
        isStrongPassword(passwords.retypePassword) &&
        areEqual(passwords.password, passwords.retypePassword)

    return (
        <ContainerGlogal>
            <SimpleGoBackBtn />
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <View style={styles.container}>
                    <BreeSerifText
                        style={{ textAlign: "center", fontSize: 20, color: baseColors.green.primary, paddingTop: 10 }}
                    >
                        Créer un nouveau mot de passe .
                    </BreeSerifText>

                    <View style={{ marginTop: 30 }}>
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setPasswords((old) => ({ ...old, password: text }))
                            }}
                            valid={isStrongPassword(passwords.password)}
                            value={passwords.password}
                            type={"password"}
                            validation_message={"min. 8 caractères"}
                            label={"Nouveau mot de passe"}
                            placeholder={"Minimum 8 caractères"}
                        />
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setPasswords((old) => ({ ...old, retypePassword: text }))
                            }}
                            valid={isStrongPassword(passwords.retypePassword)}
                            value={passwords.retypePassword}
                            type={"password"}
                            validation_message={"min. 8 caractères"}
                            label={"Confirmer le mot de passe"}
                            placeholder={"Minimum 8 caractères"}
                        />
                        {!areEqual(passwords.password, passwords.retypePassword) && (
                            <View
                                style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center"
                                }}
                            >
                                <BreeSerifText
                                    textAlign={"center"}
                                    color={baseColors.orange.primary}
                                    fontSize={16}
                                    fontWeight={"normal"}
                                >
                                    Les deux mot de passes ne sont pas identiques.
                                </BreeSerifText>
                            </View>
                        )}
                    </View>

                    {!isNotValidPassword && <PasswordValidatorContent />}

                    <Button
                        loading={loading}
                        disabled={loading || !isNotValidPassword}
                        onPress={() => performResetPassword()}
                        text="Enregistrer"
                        width="80%"
                        height={45}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 0,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
